import React from "react";
import "./loader.css"; // You can style your loader here
import IMG from "../../assets/loader/loader.gif";
const Loader = () => {
  return (
    <div className="loader-overlay">
      {/* <div className="loader"> */}
      <img
        src={IMG}
        alt="loader"
        className="w20 stloaderImg"
        style={{ borderRadius: "8px" }}
      />
      {/* </div> */}
    </div>
  );
};

export default Loader;
